// SRP-based Cognito auth, matching dealroom-fe/packages/auth/src/services/aws/cognito/CognitoClient.ts.
// Uses USER_SRP_AUTH flow — works with the same dev pool client without enabling USER_PASSWORD_AUTH.
import { CognitoUserPool, CognitoUser, AuthenticationDetails, CognitoRefreshToken, } from 'amazon-cognito-identity-js';
import { config } from '../config';
const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.userPoolId,
    ClientId: config.cognito.clientId,
});
export function login(email, password) {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    user.setAuthenticationFlowType('USER_SRP_AUTH');
    return new Promise((resolve, reject) => {
        user.authenticateUser(new AuthenticationDetails({ Username: email, Password: password }), {
            onSuccess: (session) => {
                resolve({
                    IdToken: session.getIdToken().getJwtToken(),
                    AccessToken: session.getAccessToken().getJwtToken(),
                    RefreshToken: session.getRefreshToken().getToken(),
                    // Cognito ID tokens default to 1h.
                    ExpiresIn: 3600,
                });
            },
            onFailure: (err) => reject(new Error(err.message || String(err))),
            newPasswordRequired: () => reject(new Error('New password required — please log in via the main app first')),
            mfaRequired: () => reject(new Error('MFA not supported in v1 of the add-in')),
        });
    });
}
export function refresh(email, refreshToken) {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    return new Promise((resolve, reject) => {
        user.refreshSession(new CognitoRefreshToken({ RefreshToken: refreshToken }), (err, session) => {
            if (err)
                return reject(new Error(err.message || String(err)));
            resolve({
                IdToken: session.getIdToken().getJwtToken(),
                AccessToken: session.getAccessToken().getJwtToken(),
                ExpiresIn: 3600,
            });
        });
    });
}
